export class FeedbackDTO {

  constructor(
    readonly comment: string,
    readonly screenshot?: File | null
  ) {
  }
}